module.exports = __webpack_public_path__ + "img/icone_transp.d65b64bc.png";